import Vue from 'vue'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import { ManualShipmentRuleResponse } from '@/api/services/common.dto'
import {
    ManualShipmentRuleCreateRequest,
    ManualShipmentRulePatchInBatchRequest
} from '@/modules/configurationModule/detail/shipments/shipment-rules/services/manual-shipment-rule/manual-shipment-rule.dto'

export default class ManualShipmentRuleService extends Vue {
    async paginator(filterModel: any, params: any): Promise<IResponseAgGrid<ManualShipmentRuleResponse>> {
        const response = await this.axios.put<IResponseAgGrid<ManualShipmentRuleResponse>>(`/configuration/manualShipmentRules/`, filterModel, { params })
        return response.data
    }
    async getShipmentRuleById(shipmentRuleId : number): Promise<ManualShipmentRuleResponse> {
        const response = await this.axios.get<ManualShipmentRuleResponse>(`/configuration/manualShipmentRules/${shipmentRuleId}`)
        return response.data
    }
    async patchShipmentRulesBatch(request: ManualShipmentRulePatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await this.axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/manualShipmentRules/batch`, request)
        return response.data
    }
    async createShipmentRule(request: ManualShipmentRuleCreateRequest): Promise<ManualShipmentRuleResponse> {
        const response = await this.axios.post<ManualShipmentRuleResponse>(`/configuration/manualShipmentRules/`, request)
        return response.data
    }
    async deleteShipmentRulesBatch(request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await this.axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/manualShipmentRules/batch`, { data: request })
        return response.data
    }
}

export const manualShipmentRuleService = new ManualShipmentRuleService()
